import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Layout, message } from 'antd';
import {
  LeftOutlined,
  DownloadOutlined,
  CopyOutlined,
} from '@ant-design/icons';
const { Content } = Layout;

const DownloadPage = () => {
  const navigate = useNavigate();
  const { docInfo } = useParams();
  const [loading, setLoading] = useState(false);

  if (!docInfo) {
    navigate('/');
    return null;
  }

  let url, title;

  try {
    const decodedInfo = decodeURIComponent(docInfo);
    console.log(decodedInfo, '语雀链接');
    [url, title] = decodedInfo.split('||');
  } catch (error) {
    console.error('Failed to parse document info:', error);
    message.error('无效的文档链接');
    navigate('/');
    return null;
  }

  const handleDownload = async () => {
    if (loading) return; // 如果已经在加载，则不处理
    setLoading(true); // 开始加载

    const urlWithoutParams = url.split('?')[0];
    const [group_login, book_slug, id] = urlWithoutParams.split('/').slice(-3);

    try {
      message.success('正在下载文件,请稍等');
      const response = await fetch(
        `https://poweris.inhand.online/api/yuque/download?group_login=${group_login}&book_slug=${book_slug}&id=${id}`
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      console.log(title, 'title1111');
      const blob = await response.blob();
      console.log(blob, 'blob');
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${title}`; // 或者根据服务器返回的文件名动态设置
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('下载失败:', error);
      message.error('下载失败，请稍后重试');
    } finally {
      setLoading(false); // 无论成功还是失败，都结束加载状态
    }
  };

  const handleyuque = () => {
    window.open(url, '_blank');
  };

  return (
    <Layout>
      <Content style={{ padding: '20px', minHeight: '100vh' }}>
        <div
          style={{
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Button
            icon={<LeftOutlined />}
            onClick={() => navigate(-1)}
            style={{ marginRight: '16px' }}
          >
            返回
          </Button>
          <h2 style={{ margin: 0, flex: 1 }}>{title || '用户手册'}</h2>
          {/* <Button
            icon={<CopyOutlined />}
            onClick={handleyuque}
            type='primary'
            style={{ marginRight: '16px' }}
          >
            访问原文档
          </Button> */}

          <Button
            loading={loading}
            disabled={loading}
            icon={<DownloadOutlined />}
            onClick={handleDownload}
            type='primary'
          >
            下载该手册
          </Button>
        </div>

        <div
          style={{
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            height: 'calc(100vh - 100px)',
          }}
        >
          <iframe
            src={url}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '8px',
            }}
            title={title || '用户手册'}
          />
        </div>
      </Content>
    </Layout>
  );
};

export default DownloadPage;
